
const state = {
	condition: {},
	auditParams: {
		isBack: false,
		toName:''
	},
	minimumOrderStoreList: [],
	sendPactRetailerList: [],
}

const mutations = {
	changeCondition (state,payload){
		state.condition = payload;
	},
	changeAuditParams (state,payload){
		state.auditParams = payload;
	},
	changeMinimumOrderStoreList (state,payload){
		state.minimumOrderStoreList = payload;
	},
	changeSendPactRetailerList (state,payload){
		state.sendPactRetailerList = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/listSearch.js